module.exports = __webpack_public_path__ + "img/thumb.d2c4db99.png";